import store from '@/store';

import Actions from './actions.type';

import type { CommonReq, CommonNewOrChangeReq, CommonDelReq } from './types';

async function dispatch(action, params) {
  return await store.dispatch('common/'+action, params)
}

export default {
  // Получение списка объектов указанного модуля
  async getItems(params: CommonReq) {
    return await dispatch(Actions.GET_ITEMS, params);
  },
  async getItem(params: CommonReq) {
    return await dispatch(Actions.GET_ITEM, params);
  },
  async newItem(params: CommonNewOrChangeReq) {
    return await dispatch(Actions.NEW_ITEM, params);
  },
  async editItem(params: CommonNewOrChangeReq) {
    return await dispatch(Actions.EDIT_ITEM, params);
  },
  async delItem(params: CommonDelReq) {
    return await dispatch(Actions.DEL_ITEM, params);
  },
  toggleDevInfo() {
    store.commit('common/TOGGLE_DEV_INFO');
  },
  items(module: string) {
    return store.state[module].list
  },
  item(module: string) {
    return store.state[module].item
  },
}